import { createAction } from '@reduxjs/toolkit';
import { api } from '@/lib/trpc/client';

export const getSalesOrdersReportCampaigns = createAction('sales-orders-report/campaigns/get');
export const getSalesOrdersReportCampaignsFailed = createAction(
  'sales-orders-report/campaigns/failed'
);
export const getSalesOrdersReportCampaignsSucceeded = createAction(
  'sales-orders-report/campaigns/succeeded'
);

function getTrcpErrorMessage(error) {
  return error?.message || error?.data?.code;
}

export const getProductCampaignData = (campaigns, productIds, callback) => (dispatch, getState) => {
  dispatch(getSalesOrdersReportCampaigns());

  const state = getState();
  const userState = state.user;
  const { activeChain } = userState;

  return api.salesOrders.getProductCampaignData
    .query({
      campaigns,
      productIds,
      chain: activeChain,
    })
    .then(
      (data) => {
        if (data.result) {
          dispatch(getSalesOrdersReportCampaignsSucceeded());
          callback(data.result);
        } else {
          dispatch(getSalesOrdersReportCampaignsFailed());
        }
      },
      (error) => dispatch(getSalesOrdersReportCampaignsFailed(getTrcpErrorMessage(error)))
    );
};
